var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-select",
    {
      staticClass: "w-100 block-picker",
      attrs: {
        showSearch: "",
        placeholder: _vm.$t("chatbotv2.selectABlock"),
        notFoundContent: _vm.$t("chatbotv2.noBlocksFound"),
        size: "large",
        "filter-option": false,
      },
      on: {
        change: _vm.handleChange,
        search: _vm.handleSearch,
        select: _vm.handleSelect,
      },
      model: {
        value: _vm.selectedBlockId,
        callback: function ($$v) {
          _vm.selectedBlockId = $$v
        },
        expression: "selectedBlockId",
      },
    },
    _vm._l(_vm.getFilteredResult(), function (result, index) {
      return _c(
        "a-select-option",
        {
          key: result.id,
          staticClass: "block-picker-item",
          attrs: { value: result.id },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-3 d-flex flex-column justify-content-center",
              },
              [
                _c(
                  "span",
                  [
                    _c("BlockIconPreview", {
                      staticClass: "img",
                      staticStyle: { "font-size": "16px" },
                      attrs: { "block-type": result.type },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-9" }, [
              _c("span", { staticClass: "blockTypeText" }, [
                _vm._v(_vm._s(result.name || result.type)),
              ]),
            ]),
          ]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }